<!-- src/components/SearchTextInput.vue -->
<script setup>
import { ref, watch } from "vue";
import { useActivityStore } from "@/stores/useActivityStore";
import { useTextStore } from "@/stores/useTextStore";

import debounce from "lodash.debounce";

const activityStore = useActivityStore();
const textStore = useTextStore();

const search = ref(activityStore.searchTerm);
//alert("textStore.idText: " + textStore.idText);
//alert("activityStore.searchTerm" + activityStore.searchTerm);

// Debounced fetch com atraso de 400ms
const debouncedSearch = debounce(async () => {
  activityStore.currentPage = 1;
  activityStore.searchTerm = search.value;
  activityStore.shouldForcePageOne = true; // ✅ sinaliza para BottomPagination mudar foco
  //alert('searchTerm: ' + store.searchTerm);
  await activityStore.fetchActivitiesPaged(
    1,
    activityStore.pageSize,
    activityStore.searchTerm,
    textStore.idText
  );
}, 400);

// Assiste mudanças na digitação
watch(search, () => {
  debouncedSearch();
});
</script>

<template>
  <div class="search-input-wrapper">
    <div class="icon-wrapper">
      <svg
        aria-hidden="true"
        class="search-icon"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>
    
    <input
      v-model="search"
      type="text"
      id="simple-search"
      placeholder="Buscar por título, descrição e criador"
      class="input-base" 
      style="padding-left: 2rem"
    />
  </div>
</template>
<style scoped>
.search-icon {
  width: 1rem;
}

.search-input {
  height: 34px;
}

</style>